import { ChangeDetectionStrategy, Component, OnInit, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { LayoutService } from 'app/layout/layout.service';
import { MsAbstractBaseDialog } from '../../base/base-dialog';
import { DialogCounterService } from '../service/dialog-counter.service';

import { NgTemplateOutlet } from '@angular/common';
import { SafeHtmlPipe } from '@ms/core/pipes/sanitize-html.pipe';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@Component({
    selector: 'app-simple-dialog',
    templateUrl: './simple-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, FlexLayoutModule, MatButtonModule, TranslatePipe, SafeHtmlPipe, NgTemplateOutlet],
})
export class SimpleDialogComponent extends MsAbstractBaseDialog implements OnInit {
    style: number;
    title: string;
    message: string;
    information: string;
    subInformation: string;
    button: number;
    allowOutsideClick: boolean;
    captions: string[] = [];
    template: TemplateRef<any>;
    constructor(public layoutService: LayoutService) {
        super();
        this.style = this.data.style || 0;
        this.title = this.data.title;
        this.message = this.data.message;
        this.information = this.data.information;
        this.subInformation = this.data.subInformation;
        this.button = this.data.button;
        this.captions = this.data.captions || [];
        this.template = this.data.template ?? null;
        this.dialogRef.disableClose = !this.data.allowOutsideClick || true;
        DialogCounterService.currentDialog.push(this.dialogRef.id);
    }

    ngOnInit() {
        super.ngOnInit();
        if (!this.captions || this.captions.length == 0) {
            if (this.button == 0) {
                this.captions = ['GENERAL.BUTTON.YES'];
            }
            if (this.button == 1) {
                this.captions = ['GENERAL.BUTTON.YES', 'GENERAL.BUTTON.CANCEL'];
            }
            if (this.button == 2) {
                this.captions = ['GENERAL.BUTTON.YES', 'GENERAL.BUTTON.NO'];
            }
            if (this.button == 3) {
                this.captions = ['GENERAL.BUTTON.ACCEPT', 'GENERAL.BUTTON.REJECT'];
            }
            if (this.button == 4) {
                this.captions = ['GENERAL.BUTTON.YES', 'GENERAL.BUTTON.NO', 'GENERAL.BUTTON.CANCEL'];
            }
        }
    }

    onOk() {
        if (this.dialogRef) {
            this.dialogRef.close({ result: 'ok' });
        }
    }
    onCancel() {
        if (this.dialogRef) {
            this.dialogRef.close({ result: 'cancel' });
        }
    }
    onYes() {
        if (this.dialogRef) {
            this.dialogRef.close({ result: 'yes' });
        }
    }
    onNo() {
        if (this.dialogRef) {
            this.dialogRef.close({ result: 'no' });
        }
    }
    onAccept() {
        this.dialogRef.close({ result: 'accept' });
    }
    onReject() {
        if (this.dialogRef) {
            this.dialogRef.close({ result: 'reject' });
        }
    }
}
